import { GuardianApplicant } from '@project-minerva/typings'
import { startOfYear, sub } from 'date-fns'

export const hasMissingProfileSteps = (applicant: Pick<GuardianApplicant, 'invigilationCentre' | 'isSend' | 'isEal'>) =>
  applicant.invigilationCentre === null || applicant.isSend === null || applicant.isEal === null

export const MAX_DOB = startOfYear(sub(new Date(), { years: 8 }))
export const MIN_DOB = startOfYear(sub(new Date(), { years: 15 }))
